import useScreenSize from "../../hooks/useScreenSize";

export default useScreenSize;
